var _rect, _rect2, _line, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnimImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1012,
    height: 589,
    viewBox: "0 0 1012 589",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1011,
    height: 588,
    rx: 19.5,
    fill: "white",
    stroke: "#ECEBEE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 12,
    width: 276,
    height: 18,
    rx: 9,
    fill: "#ECEBEE"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 43.5,
    x2: 1012,
    y2: 43.5,
    stroke: "#ECEBEE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.3684,
    cy: 23.3684,
    r: 5.36842,
    fill: "#FF6633"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 23.3684,
    r: 5.36842,
    fill: "#FCE80F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.6316,
    cy: 23.3684,
    r: 5.36842,
    fill: "#28DDCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimImg);
export default __webpack_public_path__ + "static/media/anim-img.222790882b08e807681fa6ef6c91a5d2.svg";
export { ForwardRef as ReactComponent };